<div
  #dietFormModal
  class="modal fade modal-lg"
  id="foodOptionsFormModal"
  tabindex="-1"
  aria-labelledby="dietFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="editing">
          Edición de una comida
        </h1>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="!editing">
          Creación de una comida
        </h1>
        <button
          type="button"
          class="btn-close"
          (click)="onClose()"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="foodOptionForm" (ngSubmit)="onSubmit()">
          <div class="mb-3 form-floating">
            <input
              class="form-control"
              list="datalistOptions"
              id="foodList"
              (input)="selectFoodFromInput()"
              formControlName="foodName"
              placeholder="Escribe un alimento..."
              autocomplete="off"
            />
            <label for="foodList">Comida</label>

            <datalist id="datalistOptions" style="width: 100%">
              <option *ngFor="let food of foods" [value]="food.name"></option>
            </datalist>
          </div>

          <div class="input-group">
            <div class="form-floating mb-3">
              <input
                class="form-control"
                (input)="selectFoodFromInput()"
                type="number"
                [ngClass]="{
                  'is-invalid': portion.invalid && portion.touched
                }"
                placeholder="porción del alimento"
                formControlName="portion"
              />

              <label
                *ngIf="selectedFood && selectedFood!.portionMeasure == '100GR'"
                >Porción en Gramos</label
              >
              <label
                *ngIf="selectedFood && selectedFood!.portionMeasure == 'UNIT'"
                for=""
                >Porción en Unidades</label
              >
              <label
                *ngIf="selectedFood && selectedFood!.portionMeasure == 'SPOON'"
                for=""
                >Porción en Cucharadas</label
              >

              <label *ngIf="!selectedFood">Porción</label>
            </div>
          </div>
          <div *ngIf="portion.invalid && portion.touched" class="text-danger">
            Ingrese una porción valida.
          </div>

          <div class="input-group" *ngIf="showPortionReferenceType">
            <div class="form-floating mb-3">
              <select
                class="form-select"
                formControlName="portionReferenceType"
              >
                <option value="KCAL">Kcal</option>
                <option value="PROTEIN">Proteínas</option>
                <option value="CARBS">Carbohidratos</option>
                <option value="FATS">Grasas</option>
                <option value="">Sin comidas equivalentes</option>
              </select>
              <label for="portionReferenceType"
                >Priorización para equivalencias</label
              >
            </div>
          </div>

          <div class="" *ngIf="selectedFood && selectedFoodMacros">
            <span class="fw-bold fs-4">DATOS NUTRICIONALES</span>
            <div
              class="border rounded-2 p-3 d-flex justify-content-around align-items-center flex-column"
            >
              <div class="d-flex">
                <div
                  class="d-flex flex-column justify-content-center align-items-center mx-1"
                >
                  <span class="fw-bold">Proteínas</span>
                  <span>{{ selectedFoodMacros!.proteins | truncate }}gr</span>
                </div>

                <div
                  class="d-flex flex-column justify-content-center align-items-center mx-1"
                >
                  <span class="fw-bold">Carbohidratos</span>
                  <span
                    >{{ selectedFoodMacros!.carbohydrates | truncate }} gr</span
                  >
                </div>

                <div
                  class="d-flex flex-column justify-content-center align-items-center mx-1"
                >
                  <span class="fw-bold">Grasas</span>
                  <span>{{ selectedFoodMacros!.fats | truncate }} gr</span>
                </div>
              </div>

              <div class="d-flex">
                <div
                  class="d-flex flex-column justify-content-center align-items-center mx-1"
                >
                  <span class="fw-bold">Fibra</span>
                  <span>{{ selectedFoodMacros!.fiber | truncate }} gr</span>
                </div>

                <div
                  class="d-flex flex-column justify-content-center align-items-center mx-1"
                >
                  <span class="fw-bold">kcal</span>
                  <span>{{ selectedFoodMacros!.kcal | truncate }} kcal</span>
                </div>
              </div>
            </div>
          </div>

          <button
            [disabled]="foodOptionForm.invalid"
            class="col-12 mt-3 d-grid btn-custom"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span *ngIf="editing">Editar</span>
            <span *ngIf="!editing">Crear</span>
          </button>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="onClose()"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
